<template>
  <div class="info">
    <Header :userinfo="userInfo"></Header>
    <div class="info-box">
      <div class="left">
        <div class="name">
          <img :src="userInfo.avatarUrl" alt="">
          <p>{{userInfo.name}}</p>
        </div>
        <div class="step">
          <ul>
            <li v-for="(tab, index) in tabList" :key="tab.id" :class="index === curTab ? 'on' : ''" :data-id="index" @click="tabChange">
              {{index + 1}}.{{tab.title}}
              <i class="finished" v-if="onLock >= index"></i>
            </li>
          </ul>
        </div>
      </div>
      <div class="right">
        <!-- 个人信息 -->
        <PersonInfo v-if="curTab === 0" :personInfo="infoDetail.personalInfo" @hasFinish="hasFinish"></PersonInfo>
        <!-- 学历信息 -->
        <EducationInfo v-if="curTab === 1" :educationInfo="infoDetail.eduInfo" @hasFinish="hasFinish"></EducationInfo>
        <!-- 单位信息 -->
        <UnitInfo v-if="curTab === 2" :institutionInfo="infoDetail.institutionInfo" @isManagement="isManagement" @hasFinish="hasFinish"></UnitInfo>
        <!-- 任教信息 -->
        <TeachInfo v-if="curTab === 3" :workInfo="infoDetail.workInfo" @hasFinish="hasFinish"></TeachInfo>
        <!-- 职务信息 -->
        <PositionInfo v-if="curTab === 4" :dutyInfo="infoDetail.dutyInfo" @hasFinish="hasFinish"></PositionInfo>
        <div class="back-home" @click="backHome">返回首页</div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer'
import PersonInfo from '@/components/information/person_info'
import EducationInfo from '@/components/information/education_info'
import UnitInfo from '@/components/information/unit_info'
import TeachInfo from '@/components/information/teach_info'
import PositionInfo from '@/components/information/position_info'
import api from '../utils/api'
import { Loading } from 'element-ui'
export default {
  name: 'Information',
  components: {
    Header,
    Footer,
    PersonInfo,
    EducationInfo,
    UnitInfo,
    TeachInfo,
    PositionInfo
  },
  inject: ['reload'],
  data () {
    return {
      userInfo: JSON.parse(window.sessionStorage.getItem('userInfo')),
      curTab: 0,
      onLock: -1,
      tabList: [],
      infoDetail: {},
      isManage: false // 是否管理部门
    }
  },
  created () {
    this.loadingInstance = Loading.service()
    // 获取用户所有信息
    api.post('GetSZTeacherPersonalInfoRequest', {}, res => {
      // console.log(res)
      let d = res.body
      this.infoDetail = d
      this.onLock = d.finishOffset - 1
      //  完成状态
      if (this.onLock < 0) {
        // 清除所有信息sessionStorage
        if (window.sessionStorage.getItem('localPersonInfo')) {
          window.sessionStorage.removeItem('localPersonInfo')
        }
        if (window.sessionStorage.getItem('eduInfoLocal')) {
          window.sessionStorage.removeItem('eduInfoLocal')
        }
        if (window.sessionStorage.getItem('loaclInstitutionInfo')) {
          window.sessionStorage.removeItem('loaclInstitutionInfo')
        }
        if (window.sessionStorage.getItem('loaclTeachInfo')) {
          window.sessionStorage.removeItem('loaclTeachInfo')
        }
        if (window.sessionStorage.getItem('localDutyInfo')) {
          window.sessionStorage.removeItem('localDutyInfo')
        }
      }
      // 管理部门 左侧tab控制
      if (d.institutionInfo.belongType === 1 || d.institutionInfo.belongType === 2 || d.institutionInfo.belongType === 3) {
        this.tabList = [{
          id: 0,
          title: '个人信息'
        }, {
          id: 1,
          title: '学历信息'
        }, {
          id: 2,
          title: '单位信息'
        }]
      } else {
        this.tabList = [{
          id: 0,
          title: '个人信息'
        }, {
          id: 1,
          title: '学历信息'
        }, {
          id: 2,
          title: '单位信息'
        }, {
          id: 3,
          title: '任教信息'
        }, {
          id: 4,
          title: '职务信息'
        }]
      }
      this.loadingInstance.close()
    })
  },
  methods: {
    tabChange (e) {
      let index = parseInt(e.target.dataset.id)
      let curT = this.onLock + 1
      if (index > curT) {
        switch (curT) {
          case 0:
            this.$message({
              message: '请先完成个人信息',
              type: 'error'
            })
            break
          case 1:
            this.$message({
              message: '请先完成学历信息',
              type: 'error'
            })
            break
          case 2:
            this.$message({
              message: '请先完成单位信息',
              type: 'error'
            })
            break
          case 3:
            this.$message({
              message: '请先完成任教信息',
              type: 'error'
            })
            break
        }
      } else {
        this.curTab = index
      }
    },
    // 为管理部门不显示 任教信息 职务信息
    isManagement (val) {
      if (val) {
        this.tabList = [{
          id: 0,
          title: '个人信息'
        }, {
          id: 1,
          title: '学历信息'
        }, {
          id: 2,
          title: '单位信息'
        }]
      } else {
        this.tabList = [{
          id: 0,
          title: '个人信息'
        }, {
          id: 1,
          title: '学历信息'
        }, {
          id: 2,
          title: '单位信息'
        }, {
          id: 3,
          title: '任教信息'
        }, {
          id: 4,
          title: '职务信息'
        }]
      }
    },
    // 是否完成
    hasFinish (index) {
      // 未完成
      if (this.onLock < 5) {
        // console.log(index)
        if (index === 0) {
          this.reload()
        }
        this.onLock = index
      }
    },
    // 返回首页
    backHome () {
      this.$router.push({ name: 'panel' })
    }
  }
}
</script>
<style scoped>
  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }
  .info-box {
    flex: 1;
    display: grid;
    grid-template-columns: 200px 760px;
    width: 960px;
    min-height: 689px;
    margin: 26px auto;
    background: #fff;
  }
  .info-box .left {
    border-right: 1px solid #e5e5e5;
  }
  .left .name {
    text-align: center;
    padding-top: 39px;
  }
  .left .name img {
    width: 60px;
    height: 60px;
    border-radius: 30px;
  }
  .left .name p{
    margin: 5px 0;
  }
  .left .step {
    margin-top: 30px;
  }
  .step li {
    position: relative;
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #666;
    font-size: 14px;
    cursor: pointer;
  }
  .step li:hover, .step li.on {
    background: #f7f7f7;
    color: #000;
  }
  .step li.on {
    font-weight: bold;
  }
  .step li i.finished {
    position: absolute;
    top: 21px;
    right: 40px;
    display: inline-block;
    width: 12px;
    height: 8px;
    background: url('../assets/tick.png') no-repeat;
    background-size: 12px 8px;
    vertical-align: middle;
  }
  .right {
    position: relative;
    padding: 35px;
  }
  .back-home {
    position: absolute;
    bottom: 20px;
    right: 20px;
    color: #008fe6;
    font-size: 14px;
    cursor: pointer;
  }
</style>
